"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.function.bind.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/esnext.weak-map.delete-all.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var React = _interopRequireWildcard(require("react"));
var _AccordionCaretDown = _interopRequireDefault(require("@lmig/design-system-icons-react/_cjs/system/AccordionCaretDown"));
require("../icons.css");
var _excluded = ["className", "color", "title"],
  _excluded2 = ["aria-hidden"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var IconAccordionCaretDown = function IconAccordionCaretDown(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'blue' : _ref$color,
    title = _ref.title,
    iconProps = _objectWithoutProperties(_ref, _excluded);
  var _iconProps$ariaHidde = iconProps['aria-hidden'],
    ariaHidden = _iconProps$ariaHidde === void 0 ? 'true' : _iconProps$ariaHidde,
    rest = _objectWithoutProperties(iconProps, _excluded2);
  return /*#__PURE__*/React.createElement(_AccordionCaretDown["default"], _extends({
    className: className,
    color: color,
    title: title,
    "aria-hidden": ariaHidden
  }, rest));
};
IconAccordionCaretDown.propTypes = {
  /** Add an optional ID to this element: `<svg class="lm-Icon">`. */id: _propTypes["default"].string,
  /** Apply a color to the icon.
     * @default 'blue'
     */
  color: _propTypes["default"].oneOf(['blue', 'caution', 'disabled', 'gray', 'informative', 'inverse', 'negative', 'positive', 'teal']),
  /** Specifies the actual size of the inner svg icon.
     * @default '16'
     */
  size: _propTypes["default"].oneOf(['16']),
  /** Add custom classes to this element: `<svg class="lm-Icon">`. */className: _propTypes["default"].string,
  /** Similar to the "alt" attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */title: _propTypes["default"].string
};
var _default = exports["default"] = IconAccordionCaretDown;